import _u from './utility';
import defaults from './defaults.js';

let locals = function() {
	let domSplit = document.domain.split('.');
	let s_subdomain = domSplit[0];
	let s_domain = domSplit[domSplit.length - 2] + '.' + domSplit[domSplit.length - 1];
	if (document.domain.match(/\.\w\w\.\w\w$/) != null) { // Two 2-letter domain suffix at end, e.g. 'co.uk' {		
		s_domain = domSplit[domSplit.length - 3] + '.' + domSplit[domSplit.length - 2] + '.' + domSplit[domSplit.length - 1];
	}
	let main_domain_name = s_domain.split('.')[0];
	let intSiteRegEx = new RegExp(main_domain_name + '\\.(com|org|' + s_domain.split(/\.(.+)/)[1].replace('.','\\.') + ')');
	let modVarPass = {};
	if (_u.readC("modvpass") && _u.readC("modvpass") !== "undefined") {
		try {
			modVarPass = JSON.parse(decodeURIComponent(_u.readC("modvpass")));
		} catch (e) {}
	}
	let dataCenter = 'ntc';
	if (typeof PageMetadata != 'undefined' && typeof PageMetadata.dc == 'string') {
		dataCenter = PageMetadata.dc;
	}
	
	return {	
		s_ver : dataCenter + '|<%= beaconVer %>|<%= date %>',
		s_domain : s_domain,
		s_subdomain : s_subdomain,
		main_domain_name : main_domain_name,
		s_shtitle : '',
		contextClrArr : [],
		modVarPass : modVarPass,
		intSiteRegEx : intSiteRegEx,
		defaultPV : true,
		globFunc : [ // Functions to export to global (window object)
			'addLinkTrackVars',
			'remLinkTrackVars',
			'wmdSetContext',
			'wmdRemContext',
			'wmdTrack',
			'wmdPageLink',
			'wmdPageview'
		],
		isInitialized : false,
		firstPvDone : false
	}
	
}();

// Check for PageMetadata / DFPTargetKeys object
if (typeof window.PageMetadata == 'undefined' && typeof window.DFPTargetKeys == 'object') {
	window.PageMetadata = window.DFPTargetKeys;
} else if (typeof window.PageMetadata == 'undefined' ) {
	window.PageMetadata = {};
}
if (typeof window.PageMetadata == 'object' && typeof window.DFPTargetKeys == 'object' && window.DFPTargetKeys != window.PageMetadata) {
	if (typeof window.PageMetadata['pageSegVars'] == 'undefined' && typeof window.DFPTargetKeys['pageSegVars'] != 'undefined') {
		window.PageMetadata['pageSegVars'] = window.DFPTargetKeys['pageSegVars'];
	}
}

let _v = {};
Object.assign(_v, locals);

if (typeof window.beaconDefaults === 'object') { // Check for optional default overwrites
	_u.mergeDeep(defaults, window.beaconDefaults);
}
Object.assign(_v, defaults);

let g = _v.globReqDefault;

_v.globVar.forEach(function(e, i) {  // Check for presence of Global overrides
	if (typeof window[e] !== 'undefined') {
		g[e] = window[e];
	}
});

if (typeof g['s_linkTrackExtend'] === "string") {
	g['s_linkTrackExtend'] = g['s_linkTrackExtend'].replace(/(contextData\.)?wb\./g,'contextData.wb.');
	g['s_linkTrackVars'] = String(g['s_linkTrackVars'] + ',' + g['s_linkTrackExtend']).replace(/^,/,'');
}

if (g['s_account'] == 'webmdcom' && (document.domain.indexOf('dev') !== -1 || document.domain.indexOf('qa') !== -1 || document.domain.indexOf('staging') !== -1)) {
	g['s_account'] = 'webmddev';
} else if (g['s_account'] == 'webmdcom') {
	g['s_account'] = 'webmdp1global';
}

if (typeof g['s_pagename'] == 'undefined') {
	g['s_pagename'] = _u.urlClean(window.location.protocol + '//' + window.location.hostname + window.location.pathname);
} else if (typeof g['s_pagename'] == 'string') {
	g['s_pagename'] = _u.urlClean(g['s_pagename']);
}

if (typeof g['s_pageurl'] != 'string') {
	g['s_pageurl'] = window.location.href;
}

if (typeof g['s_cname'] == "undefined" && typeof PageMetadata.trackSegVars != "undefined" && typeof PageMetadata.trackSegVars.cname != "undefined") {
	g['s_cname'] = PageMetadata.trackSegVars.cname;
}
if (typeof g['s_cname'] == 'undefined') {
	g['s_cname'] = _v['s_domain'];
}

if (typeof g['s_pageview_id'] == 'undefined' || g['s_pageview_id'] == null || g['s_pageview_id'].trim() == '') {
	_u.GenPVID();
	g['s_pageview_id'] = window.s_pageview_id;
}

_v.g = g;
window.s_account = g['s_account']; // Exposing 's_account' to window object, due to usage in Google AdSense Tracking, 'gasf' function
// Object.assign(window, g);

export default _v;